import React from 'react';
import { FlexRow } from '../../atoms';
import { Media, SubmissionMedia } from '../../graphql-operations';
import { CheckboxInput, RadioInput } from '../Inputs';

type Prop = {
  mediaItem: Media | SubmissionMedia;
  onSelectMediaItem?: (params: { mediaItem: Media | SubmissionMedia }) => void;
  isSelected: boolean;
  isAudio: boolean;
  disabled?: boolean;
  name: string;
  checkboxLabel: string;
  isSingleSelection?: boolean;
};

export const SelectMedia = ({
  mediaItem,
  onSelectMediaItem,
  isSelected,
  isAudio,
  disabled = false,
  name,
  checkboxLabel,
  isSingleSelection = false,
}: Prop) => {
  return (
    <FlexRow
      {...(!isAudio
        ? { className: 'cn_absolute', zIndex: 2, padding: 2, top: 0, left: 0 }
        : { mb: 2, w: 'full', justifyContent: 'center' })}
      data-testid="select-media"
    >
      {isSingleSelection && (
        <RadioInput
          name={name}
          aria-label={checkboxLabel}
          {...(isAudio ? { label: checkboxLabel } : { className: 'cn_absolute' })}
          checked={isSelected}
          value={mediaItem.id.toString()}
          onChange={() => onSelectMediaItem?.({ mediaItem })}
          size="lg"
          disabled={disabled}
        />
      )}
      {!isSingleSelection && (
        <CheckboxInput
          variant="primary"
          borderRadius="sm"
          size="lg"
          name={name}
          checked={isSelected}
          disabled={disabled}
          aria-label={checkboxLabel}
          {...(isAudio ? { label: checkboxLabel } : { className: 'cn_shadow-md cn_absolute' })}
          onChange={() => onSelectMediaItem?.({ mediaItem })}
          value={mediaItem.id.toString()}
        />
      )}
    </FlexRow>
  );
};
